import {
  userPurchaseApi,
  verifySubscriptionTokenApi,
  verifyPromoCodeApi,
  userProApi,
  bookSlotApi,
  updateBookingDataAPI,
  cancelBookingAPI,
} from "../Api/api";
import {
  verifyTokenLoad,
  verifyTokenSuccess,
  verifyTokenFailed,
  userSubscriptionPurchaseLoad,
  userSubscriptionPurchaseSuccess,
  userSubscriptionPurchaseFailed,
  verifyPromoCodeLoad,
  verifyPromoCodeSuccess,
  verifyPromoCodeFailed,
  bookSlotLoad,
  bookSlotSuccess,
  bookSlotFail,
  cancelSlotLoad,
  rescheduleSlotLoad,
  cancelSlotSuccess,
  cancelSlotFail,
  rescheduleSlotSuccess,
  rescheduleSlotFail,
} from "../slices/subscription.slice";
import appconstant from "../../themes/appconstant";
import { put, call, takeLatest } from "@redux-saga/core/effects";
import { toast } from "react-toastify";

function* verifySubscriptionSaga(action) {
  try {
    const data = yield call(verifySubscriptionTokenApi, action.payload);
    if (data.status === 0) {
      // toast.success(data?.result?.message);
      yield put(verifyTokenSuccess(data.result.data));
    } else {
      toast.error(data?.result?.message);
      yield put(verifyTokenFailed());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(verifyTokenFailed());
  }
}

function* userSubscriptionPurchase(action) {
  try {
    const data = yield call(
      action.payload.planType === "pro" ? userProApi : userPurchaseApi,
      {
        plan: action.payload.plan,
        token: action.payload.token,
      }
    );
    if (data.status === 0) {
      yield put(userSubscriptionPurchaseSuccess());
      if (data?.result?.data?.url)
        window.location.href = data?.result?.data?.url;
    } else {
      toast.error(data?.result?.message);
      yield put(userSubscriptionPurchaseFailed());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(userSubscriptionPurchaseFailed());
  }
}

function* verifyPromoCodeSaga(action) {
  try {
    const data = yield call(verifyPromoCodeApi, action.payload);
    if (data.status === 0) {
      yield put(verifyPromoCodeSuccess(data?.result?.data));
    } else {
      toast.error(data?.result?.message);
      yield put(verifyPromoCodeFailed());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(verifyPromoCodeFailed());
  }
}

function* userSlotBookingSaga(action) {
  try {
    const data = yield call(bookSlotApi, action.payload);
    if (data.status === 0) {
      yield put(bookSlotSuccess());
      if (data?.result?.data?.url)
        window.location.href = data?.result?.data?.url;
    } else {
      toast.error(data?.result?.message);
      yield put(bookSlotFail());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(bookSlotFail());
  }
}

function* cancelSlotBookingSaga(action) {
  try {
    const data = yield call(cancelBookingAPI, action.payload);
    if (data.status === 0) {
      yield put(cancelSlotSuccess());
      if (data?.result?.data?.url)
        window.location.href = data?.result?.data?.url;
    } else {
      toast.error(data?.result?.message);
      yield put(cancelSlotFail());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(cancelSlotFail());
  }
}

function* rescheduleSlotBookingSaga(action) {
  try {
    const data = yield call(updateBookingDataAPI, action.payload);
    if (data.status === 0) {
      yield put(rescheduleSlotSuccess());
      if (data?.result?.data?.url)
        window.location.href = data?.result?.data?.url;
    } else {
      toast.error(data?.result?.message);
      yield put(rescheduleSlotFail());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(rescheduleSlotFail());
  }
}

export default function* rootSubscriptionSaga() {
  yield takeLatest(verifyTokenLoad.type, verifySubscriptionSaga);
  yield takeLatest(userSubscriptionPurchaseLoad.type, userSubscriptionPurchase);
  yield takeLatest(verifyPromoCodeLoad.type, verifyPromoCodeSaga);
  yield takeLatest(bookSlotLoad.type, userSlotBookingSaga);
  yield takeLatest(cancelSlotLoad.type, cancelSlotBookingSaga);
  yield takeLatest(rescheduleSlotLoad.type, rescheduleSlotBookingSaga);
}
